document.addEventListener('DOMContentLoaded', function() {
  
  /* Selectors */
  var overlay = document.getElementById('smart-assistant-modal');
  var view1 = document.getElementById('saView1');
  var view2 = document.getElementById('saView2');
  var view3 = document.getElementById('saView3');
  var progress = document.getElementById('saProgressFill');
  var topicInput = document.getElementById('saTopicInput');
  var subjectInput = document.getElementById('saSubjectInput');
  var productTitleInput = document.querySelector('input[name="contact[produkt_title]"]');
  var bodyTextarea = document.getElementById('saBody');
  var form = document.getElementById('sa_contact_form');
  var submitBtn = document.getElementById('saSubmitBtn');
  
  if(!overlay) return;

  /* Liquid may have opened the modal already (submit outcome rendered
     server-side). Mirror the scroll-lock the JS opener applies, so the page
     behind the dialog cannot be scrolled in that case either. */
  if(overlay.classList.contains('is-open')) {
    document.body.classList.add('sa-modal-open');
  }

  /* Global open/close */
  window.openSmartAssistant = function() {
    overlay.style.display = 'flex';
    // Force reflow before adding is-open so the CSS transition fires
    overlay.getBoundingClientRect();
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sa-modal-open');

    // Reset to view 1
    view1.classList.add('sa-view--active');
    view2.classList.remove('sa-view--active');
    view3.classList.remove('sa-view--active');
    progress.style.width = '50%';
    
    // Hide old modal if it exists to prevent overlap
    var oldModal = document.getElementById('frage-modal');
    if(oldModal) oldModal.style.display = 'none';
  };

  window.closeSmartAssistant = function() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    setTimeout(function(){
      overlay.style.display = 'none';
      document.body.classList.remove('sa-modal-open');
    }, 300);
  };

  /* Step Navigation */
  window.saSelectCategory = function(topic, defaultText) {
    if(topicInput) topicInput.value = topic;

    /* Give the notification e-mail a subject support can recognise at a glance.
       `topic` is intentionally the German category label (not the translated
       row text) so contact[Thema] and this subject always read consistently
       for the German-speaking support team, regardless of storefront locale.
       `defaultText` (the pre-filled question text) IS localised — see the
       row's data-q attribute in smart-assistant-modal.liquid. */
    if(subjectInput) {
      subjectInput.value = productTitleInput
        ? topic + ' – ' + productTitleInput.value
        : topic;
    }

    // Pre-fill textarea if empty or replace if it matches another default
    if(bodyTextarea && (!bodyTextarea.value || bodyTextarea.dataset.isDefault === 'true')) {
      bodyTextarea.value = defaultText;
      bodyTextarea.dataset.isDefault = 'true';
    }

    // Switch views
    view1.classList.remove('sa-view--active');
    view2.classList.add('sa-view--active');
    progress.style.width = '100%';
    
    // Auto-focus first empty field
    setTimeout(function() {
      var nameField = document.getElementById('saName');
      if(nameField && !nameField.value) nameField.focus();
    }, 100);
  };

  window.saGoBack = function() {
    view2.classList.remove('sa-view--active');
    view1.classList.add('sa-view--active');
    progress.style.width = '50%';
  };

  /* Clear default flag on manual input */
  if(bodyTextarea) {
    bodyTextarea.addEventListener('input', function(){
      this.dataset.isDefault = 'false';
    });
  }

  /* Overlay click to close */
  overlay.addEventListener('click', function(e) {
    if(e.target === overlay) closeSmartAssistant();
  });
  
  // Escape key to close
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('is-open')) closeSmartAssistant();
  });

  /* ── File Drag & Drop Logic ── */
  var fileInput = document.getElementById('saFileInput');
  var dropZone = document.getElementById('saDropZone');
  var grid = document.getElementById('saFileGrid');
  var fileLabel = document.getElementById('saFileLabel');
  var uploadedFiles = [];

  function renderSaFiles() {
    if(!grid) return;
    grid.innerHTML = '';

    // Reveal the "sent with your message" note only while a file is attached.
    var attachNote = document.getElementById('saAttachNote');
    if(attachNote) attachNote.hidden = uploadedFiles.length === 0;

    if(uploadedFiles.length === 0) {
      grid.style.display = 'none';
      if(fileLabel) fileLabel.textContent = (window.KX_PDP_I18N && window.KX_PDP_I18N.saAttach) || 'Bild oder Dokument anhängen';
      return;
    }
    
    grid.style.display = 'grid';
    if(fileLabel) fileLabel.textContent = (window.KX_PDP_I18N && window.KX_PDP_I18N.saFilesSelected) ? window.KX_PDP_I18N.saFilesSelected.replace('%d', uploadedFiles.length) : (uploadedFiles.length + ' Datei' + (uploadedFiles.length > 1 ? 'en' : '') + ' ausgewählt');

    uploadedFiles.forEach((file, idx) => {
      var item = document.createElement('div');
      item.className = 'sa-file-item';
      
      var rmBtn = document.createElement('button');
      rmBtn.className = 'sa-file-remove';
      rmBtn.type = 'button';
      rmBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
      rmBtn.onclick = function(e){
        e.preventDefault(); e.stopPropagation();
        uploadedFiles.splice(idx, 1);
        syncSaInput();
        renderSaFiles();
      };

      if(file.type.startsWith('image/')) {
        var img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.onload = function(){ URL.revokeObjectURL(img.src); };
        item.appendChild(img);
      } else {
        var str = document.createElement('div');
        str.className = 'sa-file-item-txt';
        str.textContent = file.name.split('.').pop().toUpperCase().substring(0,4);
        item.appendChild(str);
      }
      
      item.appendChild(rmBtn);
      grid.appendChild(item);
    });
  }

  function syncSaInput() {
    if(!fileInput) return;
    var dt = new DataTransfer();
    uploadedFiles.forEach(f => dt.items.add(f));
    fileInput.files = dt.files;
  }

  if(fileInput && dropZone) {
    fileInput.addEventListener('change', function(e){
      var files = Array.from(e.target.files);
      uploadedFiles = uploadedFiles.concat(files).slice(0, 8);
      syncSaInput();
      renderSaFiles();
    });

    dropZone.addEventListener('dragover', function(e) {
      e.preventDefault(); dropZone.classList.add('is-dragover');
    });
    dropZone.addEventListener('dragleave', function(e) {
      e.preventDefault(); dropZone.classList.remove('is-dragover');
    });
    dropZone.addEventListener('drop', function(e) {
      e.preventDefault(); dropZone.classList.remove('is-dragover');
      if(e.dataTransfer.files && e.dataTransfer.files.length) {
        uploadedFiles = uploadedFiles.concat(Array.from(e.dataTransfer.files)).slice(0, 8);
        syncSaInput();
        renderSaFiles();
      }
    });
  }

  /* ── Form Submission ──
     Genuine Shopify {% form 'contact' %}, submitted NATIVELY (top-level) — the
     same mechanism as the working /contact page. We only show the spinner; the
     browser validates the required fields and performs the POST.

     Do NOT set enctype here. Shopify's contact form takes text fields only and
     has no attachment support, so forcing multipart/form-data just posts a body
     the endpoint does not expect and risks losing the submission entirely. */
  if(form) {
    form.addEventListener('submit', function(){
      submitBtn.classList.add('is-loading');
    });
  }

  /* Success/error after Shopify's redirect is rendered server-side by Liquid
     (sa_posted / sa_has_errors in snippets/smart-assistant-modal.liquid), so
     the confirmation no longer depends on this script running at all.

     This stays only as a belt-and-braces fallback, and now matches the flag with
     [?&] instead of the literal '?' it used before: real PDP URLs already carry
     a query param (?variant=…, ?srsltid=… from Google Shopping), so Shopify
     appends '&contact_posted=true' and the old check never matched — which is
     why a successful send used to show the shopper nothing. */
  if (/[?&]contact_posted=true/.test(window.location.search) &&
      !view3.classList.contains('sa-view--active')) {
    window.openSmartAssistant();
    view1.classList.remove('sa-view--active');
    view3.classList.add('sa-view--active');
  }

});
